var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"question-card custom-elevation custom-border"},[_c('v-card-text',[_vm._v(" "+_vm._s(_vm.question.definition)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }